import React from 'react'
import { Button } from '@mui/material';
import '../../styles/admin-page.css';
import { useNavigate } from 'react-router-dom';

const AdminMenuPage = () => {
  const navigate = useNavigate();
  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <h1 className="admin-page__title title">Admin</h1>
      </div>
      <Button
        variant='contained'
        size='large'
        fullWidth
        onClick={() => navigate('/admin/blogs')}
      >
        Blogs
      </Button>
      <Button
        variant='contained'
        size='large'
        fullWidth
        onClick={() => navigate('/admin/map')}
      >
        Kaart
      </Button>
    </div>
  )
}

export default AdminMenuPage
